<template>
  <div
    class="no-data flex-col items-center text-center"
    :class="backgroundColourClass"
  >
    <div
      v-if="$slots.illustration"
      class="flex justify-center mb-4 illustration-container"
    >
      <slot name="illustration" />
    </div>
    <i
      v-if="icon"
      :class="icon"
    />
    <p
      v-if="header || $slots.header"
      class="text-16 font-weight-bold text-gray-700 mb-4 header-container"
    >
      <slot name="header">
        {{ header }}
      </slot>
    </p>
    <div class="all:flex justify-center mb-7 info-container">
      <p
        v-if="info"
        :class="{ 'xl:w-1/2': condensed }"
        class="mb-0 whitespace-normal text-16"
      >
        {{ info }}
      </p>
      <slot name="info" />
    </div>
    <div class="flex flex-col items-center gap-y-4 actions-container">
      <slot name="button">
        <Button
          v-if="buttonText && !hideAction"
          color="pink"
          :icon-right="buttonIcon"
          @click="!disabled ? $emit('click') : null"
        >
          {{ buttonText }}
        </Button>
      </slot>
      <Button
        v-if="linkText && !hideAction"
        :button-text="linkText"
        color="link"
        :disabled="disabled"
        @click="$emit('clickLink')"
      />
    </div>
  </div>
</template>

<script>
import Button from '../buttons/Button';

export default {
  name: 'NoData',

  components: {
    Button,
  },

  props: {
    info: {
      type: [String, null],
      default: null,
    },

    icon: {
      type: String,
      default: '',
    },

    buttonText: {
      type: String,
      default: '',
    },

    buttonIcon: {
      type: [String, null],
      default: null,
    },

    linkText: {
      type: String,
      default: '',
    },

    disabled: {
      type: Boolean,
      default: false,
    },

    hideAction: {
      type: Boolean,
      default: false,
    },

    header: {
      type: String,
      default: '',
    },

    condensed: {
      type: Boolean,
      default: false,
    },

    backgroundColourClass: {
      type: String,
      default: 'bg-white',
    },
  },
};
</script>

<style scoped lang="scss">
.no-data {
  color: $gray-600;
  padding: 2rem;
  text-align: center;

  i {
    background-color: $purple-50;
    width: 75px;
    height: 75px;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    font-size: 2rem;
    margin-bottom: 1rem;

    &:before {
      color: $purple-800;
    }
  }
}

a {
  font-weight: bold;
}
</style>
